export default __webpack_public_path__ + "static/media/logo-white.b5e32714.png";